module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_table_of_contents_1"
    }
  }, [_c('span', [_vm._v("Prologue")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("— TU VEUX")]), _vm._v(" jouer ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian regarda l’épée en bois puis le prince héritier fou qui la tenait.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Vous m’avez vu assis ici avec un livre et vous avez décidé que cela signifiait que je voulais jouer avec vous, bande d’idiots ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Oui, répondit le Prince Turren avec la confiance d’un garçon qui avait besoin de plus de corrections.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Sebastian, cesse de te comporter comme un abruti et fais semblant d’être un enfant cinq minutes ! cria son bon à rien de frère, Démétrius.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Amusant comme il n’avait pas eu le temps de les surveiller jusqu’à ce que le roi leur rende visite.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian jeta un œil à ses deux autres frères, souriant, leurs propres épées à la main et de vieux manteaux de Père noués autour de leurs cous.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je vais passer mon tour.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il rouvrit son livre et se replongea dans des contes évoquant de véritables héros.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le prince lui arracha le livre et le tint hors de sa portée.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je t’ordonne de te joindre à nous et d’ôter ta cape. Alors, je te le rendrai.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian sauta de son tabouret.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Donc notre prochain roi est un voleur. Désolé, je n’ai pas foi en la parole des voleurs. Rendez-le-moi.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Turren pointa son épée de bois sur la poitrine de Sebastian.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Fais preuve de respect, bandit. Je serai assis sur le trône un jour.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian soupira.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Il ne vous aura pas fallu longtemps pour mêler votre père à cela.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Le Roi, pour toi.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Turren déplaça la pointe de son épée sur l’extrémité de sa capuche.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je pardonnerai ton impudence si tu l’abaisses. La porter en ma présence est une offense.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Une offense, hein ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian saisit l’épée en bois et la poussa aussi fort qu’il le put, frappant le prince avec la poignée. Il bondit sur le livre, mais, même avec le nez en sang, Turren le gardait hors de portée.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Tu veux ce maudit livre ? Le voici !")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le livre vola dans les airs en direction de la cheminée. Les bûches s’embrasèrent de flammes bleues, l’incinérant à une vitesse surnaturelle.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Qui a dit que vous pouviez utiliser la magie, gamin ? cria Démétrius.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Non !")]), _vm._v(" Sebastian fit un pas vers l’âtre, mais c’était inutile. Il avait disparu. Comme s’il avait à nouveau cinq ans, il entendit ses grands-parents lire à tour de rôle chaque poème avant le coucher. Les voix démesurées qu’ils utilisaient pour chaque histoire et les grands gestes qu’ils faisaient durant chaque bataille. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Disparu. Tout cela par la faute d’un riche prince, égoïste et pourri gâté, qui n’acceptait pas un non comme réponse.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Une main hésitante lui toucha l’épaule.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je suis désolé. J’ai perdu mon calme et…")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian le plaqua au sol.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je m’en fiche, salaud !")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ses poings frappèrent le nez toujours en sang du prince puis cognèrent le torse royal quand le connard se protégea le visage.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Démétrius sauta sur ses pieds, regardant son frère enragé puis les escaliers menant au second étage.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Au diable tout cela. Je ne vais pas rester dans les parages pour me faire hurler dessus. Que quelqu’un l’arrête si le prince s’évanouit.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il leva les yeux vers ses jeunes frères et monta les escaliers en courant.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Sebastian ! cria sa sœur, mais celui-ci ne s’arrêtait pas.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Des bras le soulevèrent dans les airs alors qu’il balançait toujours ses poings, les larmes l’aveuglant.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Calme-toi, mon garçon, lui dit une voix sévère à l’oreille.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Capitaine, je jure que Sebastian n’a jamais fait cela.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ophélia berçait le visage de son frère sous sa capuche. Elle répéta son prénom jusqu’à ce que ses bras cessent de bouger.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— C’était à moi, murmura-t-il.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le regard aveugle d’Ophélia se tourna vers la cheminée.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je sais.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le prince s’assit, du sang et de la morve coulant toujours sur son visage.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— C’était ma faute, Pembrost. S’il vous plaît, ne le punissez pas.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Cela ne dépend pas de moi, Votre Altesse. Comment a commencé cette dispute ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Avant que le prince ne puisse répondre, la porte menant à la salle de séjour s’ouvrit et Lord Orwell sortit en riant, le roi à ses côtés.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian poussa le Capitaine Pembrost et se précipita hors de la maison.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("LORD ORWELL")]), _vm._v(" attisa les flammes avec un tisonnier.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— De tous les livres inutiles de cette maison, il fallait que vous brûliez celui-ci. Pas l’un de ces romans policiers bas de gamme…")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il agita le tisonnier en direction de sa bibliothèque.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— L’une de ces romances ou un de ces récits. Vous avez brûlé le plus cher de tout ce maudit lot. Et maintenant, mon garçon se trouve Dieu sait où puisqu’il chérissait cette fichue chose plus que la vie.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Vous ne me maudissez que parce que mon père n’est pas là.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Turren regarda le Capitaine Pembrost, qui avait soigné son nez et ses ecchymoses, car il pensait que le prince ne devait pas paraître aussi indigne que son comportement.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Peut-être reviendra-t-il quand il aura faim.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Lord Orwell renifla.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Ce gamin borné ne se montrera pas avant au moins une journée.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il secoua la tête.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Toutes ces supplications pour que je ne vende pas cette maudite chose et elle finit détruite. Je m’attends à un généreux versement, je vais avoir besoin de bon vin pour noyer les jérémiades de ce garçon.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Le roi paie ses dettes, dit le Capitaine. Et vous vous acquitterez des vôtres en cherchant Sebastian s’il ne revient pas au matin, ajouta-t-il à l’intention de Turren.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— En parlant de fils pleurnicheur, où est Démétrius ? demanda Lord Orwell.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ophélia pointa le plafond.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je l’ai entendu sortir par la fenêtre quand je descendais.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Devons-nous également le chercher s’il ne rentre pas ? demanda le Capitaine Pembrost.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Ne gaspillez pas les effectifs.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Lord Orwell jeta son tisonnier au sol.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Il s’est perfectionné dans l’art de la fuite, il a probablement trouvé un passage sur un bateau à présent. Au moins, Sebastian reste sur nos terres.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Une grande partie de la faute incombe à notre prince, mais au vu de la liberté que vous accordez à vos enfants, je me demande si leur comportement ne déteint pas sur lui.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Lord Orwell croisa les bras.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Ma progéniture n’est pas parfaite, mais ils ne sont pas assez honteux pour brûler le savoir. Il est regrettable que notre prince ne possède pas l’intelligence du roi ou l’honneur de la reine.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Turren baissa la tête et ferma les yeux. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Mère sera déçue de moi quand elle entendra ce que j’ai fait.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Cela suffit, mon Seigneur. Le Prince Turren réparera cela, je le jure.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Le prince prouvera sa sincérité au matin, promit Lord Orwell.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("COMME PRÉVU,")]), _vm._v(" Sebastian ne réapparut pas au matin, Turren espéra qu’un malheur ne lui était pas arrivé. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("S’il était tombé dans un ravin et n’avait eu personne pour chercher de l’aide, ce serait de ma faute")]), _vm._v(". Plusieurs cavaliers arrivèrent du château et étalèrent une carte entre eux.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Nous aurions dû le chercher la nuit dernière, dit le Capitaine Pembrost tandis qu’il ajustait ses gants en cuir.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Bien sûr, fouiller une forêt magique la nuit, où un petit garçon peut facilement se cacher. La lumière du jour joue en notre faveur.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Lord Orwell ferma son manteau.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Et je ne veux pas être tenu pour responsable si l’un de vos soldats se faisait manger.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Soupirant, il posa sa main sur son ventre.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— L’inquiétude m’a affamé, pourtant il m’a été impossible de manger un repas complet.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Turren fronça les sourcils.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je vous ai vu avaler trois portions d’œufs ce matin.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— La disparition de mon fils vous a visiblement embrouillé, car je n’en ai pris que deux. Peut-être que le garçon devrait rester à la maison avec ma fille.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je n’ai pas besoin de sa mémoire, seulement de sa présence pour faire les choses bien.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Je suis juste là.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je vais accompagner le capitaine, car je connais mon devoir et je suis dans mon tort.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Turren s’inclina, la révérence que lui adressa Lord Orwell parvint à être à la hauteur appropriée tout en étant dédaigneuse.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Cherchez à la limite de mes terres, je chercherai plus près de la maison au cas où mon garçon retrouverait ses esprits.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Entendu, Lord Orwell.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le Capitaine Pembrost posa sa main sur l’épaule de Turren.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Venez, mon Prince.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Afin que personne ne l’accuse de se dérober à son devoir, Turren fut le premier à monter à cheval, attendant impatiemment que les gardes royaux le suivent.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Notre but est de retrouver le garçon, cela n’arrivera pas si nous sommes trop empressés et commettons des erreurs. S’il vous plaît, calmez-vous, lui conseilla le Capitaine Pembrost.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je suis extrêmement calme.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Turren dut immobiliser son cheval qui tournait en rond.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Il fait toujours cela.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Hum.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le Capitaine Pembrost leva un bras et indiqua la direction de la Forêt d’Argent.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Restez proche, ne vous égarez pas. J’ai l’intention de revenir avec le plus grand nombre possible d’entre vous.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il s’avança, suivi de l’équipe de recherche.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Turren obéit aux ordres du capitaine, mais rien autour de lui ne semblait différent d’une forêt normale. Des arbres, toujours des arbres, un cerf stoppé par un buisson, un lapin, un buisson avalant un cerf comme un biscuit. Il cligna des yeux et se tourna pour regarder l’espace vide où les feuilles flottaient dans l’air.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Faites attention à ce qu’il y a devant vous ! cria le Capitaine Pembrost et Turren fit brusquement volte-face.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Par tous les dieux, Sebastian a couru seul dans cette forêt ?")]), _vm._v(" Turren frissonna. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Nous le retrouverons et le ramènerons en sécurité chez lui. ")]), _vm._v("Des plantes grimpantes ondulaient le long des arbres et les chevaux se rapprochèrent les uns des autres. Pembrost sortit une torche de sa selle et une lueur magique rouge flamboya à son extrémité. Il la balaya d’un côté à l’autre, ce qui fit reculer les plantes. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Et si Sebastian avait été mangé ? Il y a tellement de plantes dangereuses, ce n’est qu’un enfant. Je n’aurais jamais été méchant avec lui si j’avais su qu’il s’enfuirait. Je voulais seulement qu’il me regarde.")]), _vm._v(" Turren parcourut des yeux le sol et les buissons environnants encore et encore, espérant apercevoir le tissu de la cape du jeune garçon. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Je t’en prie, sois en vie.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("SEBASTIAN RETOURNA")]), _vm._v(" le lapin et ajouta plus de sel."), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v(" Au moins, j’avais quelques épices dans mes poches")]), _vm._v(". Il maintint sa petite assiette de légumes sous son plat principal, ce qui permit au jus de lapin de tomber dessus. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Du jus de fruit serait bien, mais je suis trop paresseux après avoir chassé et dépouillé ma nourriture. ")]), _vm._v("Une plante grimpante se faufila à ses côtés et toucha la viande qui cuisait.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Va te chercher ton propre dîner !")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("La plante tapota le torse de Sebastian, mais il la repoussa.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je t’ai vue manger un oiseau un peu plus tôt alors, ne fais pas semblant d’être affamée. Maudit glouton, murmura-t-il.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("La plante s’éloigna, mais dès que Sebastian se pencha pour surveiller à nouveau son repas, elle le frappa à l’arrière de la tête et disparut trop rapidement pour qu’il lui rende son coup.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Tu sais quoi ? J’allais te donner les os, mais puisque c’est comme cela, je les donnerai à ce puits attrapeur.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Les arbres bruissèrent en réponse et Sebastian leur tira la langue. Il mit la main dans la poche de sa cape, mais celle-ci se referma sur du vide pour la troisième fois de la journée. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Quand vais-je me souvenir que mon livre a disparu à cause de ce stupide prince ?")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Au lieu de s’appesantir sur l’incident, il saisit le lapin avec des pinces et le posa sur une assiette plus grande. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("C’est très aimable de la part de la garde royale de laisser son matériel pendouiller d’un cheval sans surveillance")]), _vm._v(". La viande se détacha de l’os et il en enfourna un gros bout dans sa bouche. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Si je n’étais pas ici, car mon imbécile de père avait invité le roi ainsi que sa progéniture, ce serait un charmant dîner")]), _vm._v(". Il mangea jusqu’à ce qu’il ne reste que des déchets et le sommeil le prit. Cela avait été un long trajet jusqu’au lac et le stress ne lui faisait aucune faveur. Ses yeux se fermèrent. Quand il les ouvrit à nouveau, son assiette avait été nettoyée.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Goinfre.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("ILS TIRAIENT")]), _vm._v(" tous aussi fort que possible, mais l’énorme fleur refusait de laisser partir le soldat.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le Capitaine Pembrost était presque complètement plié en arrière tandis que lui et la majorité de leur troupe de recherche tiraient les pieds du soldat capturé. Centimètre par centimètre, l’humain couvert de substance gluante fut extrait de la fleur.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Ne lâchez pas prise ! cria-t-il.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le soldat fut enfin libre et ses camarades tombèrent au sol dans un pop sonore. Le Capitaine Pembrost leva son épée et piqua la fleur jusqu’à ce qu’elle se replie sur elle-même en une boule jaune inoffensive, comme elle leur était apparue quand ils l’avaient croisée.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Sebastian est mort et c’est de ma faute. Un jeune garçon ne peut pas s’en sortir indemne sur ce terrain. Je l’ai poussé à s’enfuir et il est mort. ")]), _vm._v("Turren frotta son nez mouillé sur sa manche et évita de regarder les autres. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Ils savent aussi probablement que c’est de ma faute. Je ne mérite pas de gouverner. Je devrais aller en prison pour ce que j’ai fait. Nous n’avons pas de prison pour enfants, mais Père devrait y réfléchir. Je serai courageux et ferai face à mon châtiment. Peut-être que dix ou quinze ans conviendraient.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Personne ne sent une odeur de lapin ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Turren cligna des yeux.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Quoi ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le Capitaine Pembrost reniflait l’air.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je la sens aussi. Je pense que nous sommes près du Lac d’Argent. Si j’étais effrayé, ce serait un bon endroit où aller.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il monta sur son cheval et cria :")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Tout le monde en selle.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le soldat visqueux s’y reprit à deux fois avant de grimper sur la sienne.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Pembrost adressa un signe de tête à l’homme et avança.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Les monstres végétaux ne cuisinent pas. ")]), _vm._v("Ayant retrouvé un peu d’espoir, Turren fit accélérer son cheval et rattrapa Pembrost. Le Capitaine tenta de le faire retourner vers l’arrière, mais il secoua la tête.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— S’il est blessé ou en danger, je l’aiderai.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Bien, cependant courez si je vous l’ordonne.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Par l’enfer, aucune chance.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Oui, Capitaine.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Pembrost peut guérir la plupart des blessures, mais je ne sais pas pour les amputations. S’il manque un membre à Sebastian, je dirai à Père de lui donner suffisamment d’argent pour vivre comme un homme normal.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Davantage de plantes les attaquèrent alors qu’ils chevauchaient vers le lac. Tout semblait aussi calme qu’au moment où ils étaient entrés dans la forêt, comme si elle se reposait. Le Capitaine écarta de longues branches qui leur barraient la route et une clairière s’ouvrit devant eux. La lumière scintillait sur le lac le plus pâle que Turren eût jamais vu. Ses eaux étaient presque blanches et, allongé sur un paquet de draps, se trouvait Sebastian. Il portait toujours sa cape, si bien que Turren ne pouvait dire si le garçon était intact. Le Capitaine fit signe aux autres de s’arrêter tandis qu’il progressait plus avant. Sebastian s’éveilla et leva ses mains au-dessus de sa tête dans un long bâillement.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Que faites-vous ici, imbéciles ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("La mâchoire de Turren se décrocha. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Il est sain et sauf. Toute cette inquiétude parce qu’il était parti depuis des heures et c’est la première chose qui sort de sa bouche ingrate ? ")]), _vm._v("Il descendit de cheval et marcha aux côtés de Pembrost.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Nous sommes ici, car tu t’es bêtement enfui. Tu aurais pu te faire tuer ! Nous aurions pu nous faire tuer !")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian se redressa.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— La dernière partie est vraie, mais la précédente est impossible : je suis un Orwell.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Une plante similaire à celles qui avaient tenté à de nombreuses reprises de les désarçonner se glissa à côté de Sebastian, qui la caressa comme un chien.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Vous pouvez rentrer et dire à mon père que je vais bien. Je ne sais pas ce qui lui a pris de vous envoyer à ma recherche.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il se rallongea et les ignora.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je suis désolé, Monsieur, mais vous rentrez avec nous.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian regarda le capitaine ainsi que les gardes qui se tenaient derrière lui. Puis ses yeux se posèrent sur Turren. Lui adressant le même regard dédaigneux que Lord Orwell, Sebastian se leva et épousseta son manteau. Il démantela son foyer et rassembla ses possessions.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Hé, c’est mon matériel ! s’exclama le soldat couvert de bave. Je pensais que mon sac s’était défait.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— C’est vrai, dit Sebastian. Je l’ai trouvé par terre et comme je ne savais pas à qui il appartenait, je m’en suis servi.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Une démangeaison se développa derrière l’oreille de Turren.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Tu mens, tu l’as volé.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Son Altesse ne devrait pas lancer d’accusations sans fondement, spécialement quand ses mœurs sont en cause.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian se dirigea vers le soldat et lui donna son sac.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Turren s’avança vers Sebastian.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je dois assumer la responsabilité de mes actions, tout comme toi. Tu t’es enfui et maintenant, tu mens. Tu m’as traité de voleur plus tôt quand il est évident que tu en es un aussi.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il frappa le côté de la capuche de Sebastian.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Quel genre d’honnête personne porte une capuche même quand le temps est clair ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian ne dit rien.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— J’ai dit, quel genre de…")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Turren empoigna la capuche. Elle se déplaça et il eut un aperçu des yeux verts clairs qui brillaient comme des péridots. Une paume claqua son abdomen. Tombant au sol, Turren chercha douloureusement de l’air et attendit que le capitaine prenne sa défense. Il n’y eut aucun mouvement. "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Très bien, je réglerai cela par moi-même.")]), _vm._v(" Il se releva lentement et le visage encapuchonné de Sebastian suivit chaque mouvement.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je n’apprécie pas d’être touché par des imbéciles. Refaites-le et je vous remettrai à terre.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Des semaines à jouer chez les Orwell et il me regarde enfin. Je peux faire ce qui est honorable, même s’il ne le mérite pas.")]), _vm._v(" Turren s’inclina.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je suis désolé d’avoir perdu mon calme et… pour le livre, murmura-t-il. Je peux en trouver une autre copie.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian se mit à rire.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je n’y crois pas une seconde. Pas même votre argent ne pourrait me procurer une autre première édition des poèmes de Sigmuend Altraius. Et dans l’éventualité peu probable que vous réussissiez, dites-moi, je vous prie, comment vous pourriez remplacer un livre imprégné de l’odeur du parfum de ma grand-mère et du tabac de mon grand-père ? Comment pourriez-vous remplacer un livre qui m’a été lu par les deux personnes qui m’aimaient plus que mes parents ? S’il vous plaît, expliquez-moi comment vous pourriez instiller ces souvenirs dans un autre livre quand tous les deux sont morts.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Turren se mordit l’intérieur de la bouche, car il ne pouvait donner de réponse appropriée.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— C’est bien ce que je pensais. Toute tentative de remplacement est une farce, nous allons donc nous en tenir à l’argent. Mon père attend certainement une restitution pécuniaire dès mon retour. Une pleine bourse d’or fera l’affaire.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Une pleine bourse ! C’est un vol ! cria Turren.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Non, crétin, c’est le prix du livre. Peut-être que lorsque vous déciderez à nouveau de brûler le savoir, vous trouverez quelque chose de moins cher.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je ne le referai plus.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Pas à moi, c’est certain.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sebastian se dirigea vers le capitaine.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je n’ai pas de cheval.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Pembrost se poussa afin que Sebastian grimpe derrière lui et il exhorta l’animal à avancer. Le Prince Turren suivit, ce fut la dernière fois qu’il vit Sebastian.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34bd1666","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0003.vue
// module id = 63
// module chunks = 0